import { useAction } from "@/hooks/shared";
import { enableCompanyHandler } from "@/services";

export const useEnableCompany = () => useAction(enableCompanyHandler);
